import styled from 'styled-components'

const ExplainerText = styled.p`
  font-size: 16px;
  color: dimgray;
  text-align: center;
  }
`

export default ExplainerText
